/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */

import * as React from 'react'
import PeopleIcon from '@mui/icons-material/People'
import NaturePeopleIcon from '@mui/icons-material/NaturePeople'
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople'
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy'
import SearchIcon from '@mui/icons-material/Search'

import {ToggleFunctionType} from "../layouts/Layout"
import GridSelectDrawer from "./GridSelectDrawer"
import {Diversity1, DownhillSkiing, Face6, FlutterDash} from "@mui/icons-material"


interface ShareNodeActionProps {
  open: boolean
  toggleDrawer: ToggleFunctionType
}


const ShareNodeDrawer: React.FC<ShareNodeActionProps> = ({open, toggleDrawer}) => {
  // const [searchItem, setSearchItem] = React.useState("")
  const [items, setItems] = React.useState([
    {text: 'Bob', icon: <DownhillSkiing/>},
    {text: 'Tim', icon: <Face6/>},
    {text: 'Some Group', icon: <PeopleIcon/>},
    {text: 'My Friends', icon: <Diversity1/>},
    {text: 'The Man', icon: <FlutterDash/>},
  ])

  const shareNode = (selectedItem: string, textInput: string) => {
    if (selectedItem && selectedItem === textInput) return true
    if (textInput) {
      // setSearchItem(textInput)
      setItems([...items, {text: textInput, icon: <PeopleIcon/>}])
    }
  }

  return (
    <GridSelectDrawer
      title="Share the Current Item with a Contact"
      subtitle="Select from the following contacts:"
      anchor="bottom"
      open={open}
      toggleDrawer={toggleDrawer}
      items={items}
      onSelect={shareNode}
      inputLabel="Selected Contact"
      inputProps={{"aria-label": "enter contact info for search"}}
      inputId="share-note-drawer-1"
      setTextOnSelection={true}
      altActionItemIcon={<SearchIcon/>}
      altInputLabel="Search for Contact"
    />
  )
}

export default ShareNodeDrawer
